import { useGameStore } from '../store/gameStore';

export function ScoreDisplay() {
    const { guessedCount, totalCount, progressPct } = useGameStore();

    return (
        <section className="overlay-container-top">
            <div id="score-section">
                <div id="score-display">
                    <span>Progress: </span>
                    <span id="guessed-count">{guessedCount}</span>
                    <span> / </span>
                    <span id="total-count">{totalCount}</span>
                </div>
                <div id="progress-container">
                    <div id="progress-bar" style={{ width: `${progressPct}%` }} />
                </div>
            </div>
        </section>
    );
}
